import React, { Component } from "react"
import { Link } from "react-router"
import Moment from "moment"

class Notification extends Component {
  render() {
    return (
      <tr>
        <th scope="row">
          {this.props.item}
        </th>
        <td>
          <Link to={"/notifications/" + this.props.id}>
            <strong>
              {this.props.name}
            </strong>
          </Link>
        </td>
        <td>
          {Moment.unix(this.props.sentAfter)
            .utc()
            .format("dddd, MMM Do YYYY - h:mm a")}
        </td>
      </tr>
    )
  }
}

export default Notification



/** WEBPACK FOOTER **
 ** ./src/components/notifications/notification.js
 **/